/** Normaliza RUT chileno a `12345678-9` (sin puntos). */
export const normalizeRut = (value) => {
    const cleaned = String(value || "")
        .trim()
        .toUpperCase()
        .replace(/\./g, "")
        .replace(/\s+/g, "")
        .replace(/-/g, "");
    if (!cleaned)
        return "";
    if (cleaned.length < 2)
        return "";
    const body = cleaned.slice(0, -1).replace(/\D/g, "");
    const dv = cleaned.slice(-1);
    if (!body || !/^[0-9K]$/.test(dv))
        return "";
    return `${body}-${dv}`.slice(0, 11);
};
/** Valida RUT chileno (módulo 11). Cadena vacía → false. */
export const isValidRut = (value) => {
    const rut = normalizeRut(value);
    if (!rut || rut.length > 11)
        return false;
    const match = rut.match(/^(\d{1,8})-([0-9K])$/);
    if (!match)
        return false;
    const body = match[1];
    const dv = match[2];
    let sum = 0;
    let multiplier = 2;
    for (let i = body.length - 1; i >= 0; i -= 1) {
        sum += Number(body[i]) * multiplier;
        multiplier = multiplier === 7 ? 2 : multiplier + 1;
    }
    const remainder = 11 - (sum % 11);
    const expected = remainder === 11 ? "0" : remainder === 10 ? "K" : String(remainder);
    return dv === expected;
};
/** Formato visual `12.345.678-5`. */
export const formatRutDisplay = (value) => {
    const rut = normalizeRut(value);
    if (!rut)
        return "";
    const [body, dv] = rut.split("-");
    const withDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${withDots}-${dv}`;
};
/** Formatea mientras el usuario escribe. */
export const formatRutInput = (value) => {
    const cleaned = value
        .toUpperCase()
        .replace(/[^0-9K]/g, "")
        .slice(0, 9);
    if (cleaned.length <= 1)
        return cleaned;
    return `${cleaned.slice(0, -1)}-${cleaned.slice(-1)}`.slice(0, 11);
};
